<template>
    <div class="paginator" v-if="pages >= 1">
        <ul>
            <li :class="{'disabled': page === 1}" v-on:click="changePage(page - 1)">
                <i class="fa fa-angle-left"></i>
                <font-awesome-icon icon="angle-left" />
            </li>
            <li v-for="item in getVisiblePages()" :class="{'active': page == item}" v-on:click="changePage(item)"
                v-if="item <= pages">
                {{ item }}
            </li>
            <li :class="{'disabled': pages === page}" v-on:click="changePage(page + 1)">
                <i class="fa fa-angle-right"></i>
                <font-awesome-icon icon="angle-right" />
            </li>
        </ul>
    </div>
</template>
<script>
    export default {
        props: {
            pages: {
                type: Number,
                'default': 1
            },
            page: {
                type: Number,
                'default': 1
            }
        },
        watch: {
            '$props.pages'() {
                this.validatePage();
            },
            '$props.page'() {
                this.validatePage();
            }
        },
        mounted() {
            this.validatePage();
        },
        methods: {
            validatePage() {
                if (this.page > this.pages) {
                    this.changePage(1);
                }
            },
            changePage(page) {
                if (page >= 1 && page <= this.pages) {
                    this.$emit('changePage', page);
                }
            },
            getVisiblePages() {
                let out = [];
                if (this.page > 3 && this.page <= (this.pages - 2) && this.pages > 5) {
                    out.push(this.page - 2);
                    out.push(this.page - 1);
                    out.push(this.page);
                    out.push(this.page + 1);
                    out.push(this.page + 2);
                    return out;
                } else if (this.page > (this.pages - 2) && this.pages > 5) {
                    out.push(this.pages - 4);
                    out.push(this.pages - 3);
                    out.push(this.pages - 2);
                    out.push(this.pages - 1);
                    out.push(this.pages);
                    return out;
                }
                return [1, 2, 3, 4, 5]
            }
        }
    }
</script>
<style lang="scss">
    .paginator {
        margin-bottom: 30px;

        ul {
            display: inline-block;
            list-style: none;
            margin: 0;
            padding: 0;

            li {
                float: left;
                background: #fff;
                width: 33px;
                height: 33px;
                line-height: 33px;
                border-radius: 0;
                font-size: 15px;
                cursor: pointer;
                margin: 0 -1 0 2px;
                font-weight: 600;
                -webkit-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;
                user-select: none;
                border-right: 1px solid #EFF1F4;
                text-align: center;

                &.disabled {
                    cursor: not-allowed;
                }

                &:hover:not(.disabled),
                &.active:not(.disabled) {
                    background: #009DFA;
                    color: #fff;
                }
            }
        }
    }
</style>
<!--#background: $primaryColor;-->
<!--#color: $secondaryText;-->



// WEBPACK FOOTER //
// src/core/InlineDataGrid/Paginator.vue